import React from 'react';
import { isEmpty } from '../../../utils';
export class SelectAdapter extends React.Component {
  componentDidUpdate(prevProps) {
    if (
      this.props.active &&
      this.props.onChange &&
      prevProps.value !== this.props.value &&
      isEmpty(this.props.value)
    ) {
      this.props.onChange(this.props.value);
    }
  }
  render() {
    return this.props.children;
  }
}
